const TEXT = {
    ProfileTitle: {
        en: "My Profile",
        ar: "ملفي الشخصي"
    },
    PersonalInformation: {
        en: "Personal Information",
        ar: "المعلومات الشخصية"
    },
    FirstName: {
        en: "First Name",
        ar: "الاسم الأول"
    },
    LastName: {
        en: "Last Name",
        ar: "اسم العائلة"
    },
    Email: {
        en: "Email Address",
        ar: "البريد الإلكتروني"
    },
    UserID: {
        en: "User ID",
        ar: "معرف المستخدم"
    },
    EditProfile: {
        en: "Edit Profile",
        ar: "تعديل الملف الشخصي"
    },
    SaveChanges: {
        en: "Save Changes",
        ar: "حفظ التغييرات"
    },
    Cancel: {
        en: "Cancel",
        ar: "إلغاء"
    },
    ChangeProfileImage: {
        en: "Change Profile Image",
        ar: "تغيير صورة الملف الشخصي"
    },
    ProfileUpdated: {
        en: "Profile updated successfully!",
        ar: "تم تحديث الملف الشخصي بنجاح!"
    },
    UpdateFailed: {
        en: "Failed to update profile",
        ar: "فشل تحديث الملف الشخصي"
    },
    ImageTooLarge: {
        en: "Image size must be less than 5MB",
        ar: "يجب أن يكون حجم الصورة أقل من 5 ميجابايت"
    },
    NoFaceDetected: {
        en: "No face detected in the image. Please upload a clear photo.",
        ar: "لم يتم اكتشاف وجه في الصورة. يرجى تحميل صورة واضحة."
    }
};

export default TEXT;
